import { gql } from '@apollo/client';

const ME_FRAGMENT = gql`
  fragment MeValues on Me {
    identityId
    userId
    emailAddress
    firstName
    active
    lastName
    organizations {
      id
      domainSuffix
      name
      stub
      emailAddress
      membershipType
      roles
      permissions
    }
    activeOrganization {
      id
      domainSuffix
      name
      stub
      emailAddress
      membershipType
      roles
      permissions
      adminRole
      supplier {
        id
      }
      customer {
        id
      }
    }
    admin
    adminToken {
      action
      tokenId
      expiry
      organization {
        id
        name
      }
    }
  }
`;

export const MUTATION_LOGIN = gql`
  ${ME_FRAGMENT}
  mutation Login($emailAddress: EmailAddress!, $password: String!) {
    login(emailAddress: $emailAddress, password: $password) {
      tokenExpiry
      accountToken
      errorMessage
      me {
        ...MeValues
      }
    }
  }
`;

export const MUTATION_LOGOUT = gql`
  mutation Logout {
    logout @client
  }
`;

export const ME_QUERY = gql`
  ${ME_FRAGMENT}
  query AUTHENTICATION_ME {
    me {
      ...MeValues
    }
  }
`;

export const MUTATION_CHANGE_ACTIVE_ORGANIZATION = gql`
  ${ME_FRAGMENT}
  mutation ChangeActiveOrganization($organizationId: Int!) {
    changeActiveOrganization(organizationId: $organizationId) {
      me {
        ...MeValues
      }
    }
  }
`;
